module.exports = __webpack_public_path__ + "static/Weekday-Template-ecdde1661fb37fab82360c5a3699e8dd.png";